package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.*
import com.exura.components.Icon
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.ui.*
import com.exura.ui.modifiers.ShadeBorder
import com.exura.ui.modifiers.insetHoverableItemStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

@Composable
internal fun ExecutionDeadlineToggle(
    hasExecutionDeadline: Boolean,
    onToggle: (Boolean) -> Unit,
    mode: PlanCreatorInputMode,
    enabled: Boolean = true,
) = EditViewSection(
    enabled = enabled,
    title = "",
    withTitle = false,
) {
    Row(
        modifier = Modifier
            .insetHoverableItemStyle(
                isSelected = hasExecutionDeadline,
                shadeSize = 8.px,
                cursor = Cursor.Pointer,
                onClick = if (mode == PlanCreatorInputMode.EDIT) {
                    { onToggle(!hasExecutionDeadline) }
                } else {
                    null
                },
                shadeBorders = listOf(
                    ShadeBorder.TOP,
                    ShadeBorder.LEFT,
                ),
                isHoverable = mode == PlanCreatorInputMode.EDIT,
            )
            .fillMaxWidth()
            .borderRadius(8.px)
            .padding(8.px)
            .textAlign(TextAlign.Center),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center,
    ) {
        Icon(
            iconSrc = Assets.IconsUntiled.CALENDAR_CLEAN,
            color = ExuraColors.BLUE,

        )

        SpanText(
            text = "Dodaj termin wykonania",
            modifier = Modifier
                .classNames(TextStyles.medium16)
                .color(ExuraColors.BLUE)
                .margin(left = 8.px)
        )
    }
}
